<template>
  <el-dialog
    title="商品详情信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="small"
    >
      <el-form-item
        label="商铺名称"
      >
        {{agentname}}
      </el-form-item>
      <el-form-item
              label="商品名称"
      >
        {{goodsname}}
      </el-form-item>
      <el-form-item
        label="价格(元)"
      >
        {{goodsprice}}
      </el-form-item>
      <el-form-item
              label="原价格(元)"
      >
        {{originalprice}}
      </el-form-item>
      <el-form-item
              label="商品图片"
      >


        <div v-if="goodsimg!=null && goodsimg!=''">
            <span v-for="item in this.goodsimg.split(',')">

               <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl2(item)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 200px; "></video><br/>
              </span>
              <span v-else>
                 <img :src= "getImgUrl2(item)" style="width: 200px;height: 200px; "/><br/>
              </span>


              </span>

        </div>


      </el-form-item>
      <el-form-item
              label="商品详情"
      >
        <div v-if="detailsimg!=null && detailsimg!=''">
            <span v-for="item in this.detailsimg.split(',')">


               <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl2(item)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 200px; "></video><br/>
              </span>
              <span v-else>
                 <img :src= "getImgUrl2(item)" style="width: 200px;height: 200px; "/><br/>
              </span>




              </span>

        </div>
      </el-form-item>
      <el-form-item
              label="总量"
      >
        {{total_num}}
      </el-form-item>

      <el-form-item
              label="已使用"
      >

        {{user_num}}
      </el-form-item>
      <el-form-item
              label="添加时间"
      >
        {{insert_times}}
      </el-form-item>

      <el-form-item
              label="是否上架"
      >

        <div v-if="type=='0' ">
          上架
        </div>
        <div v-else-if="type=='1'">
          下架
        </div>
      </el-form-item>
      <el-form-item
              label="一级分类"
      >
        {{category_name}}
      </el-form-item>
      <el-form-item
              label="二级分类"
      >
        {{category_two_name}}
      </el-form-item>
        <el-form-item
                label="产品类型"
        >
          <div v-if="meal_type=='0'">
            商家爆品
          </div>
          <div v-else-if="meal_type=='1'">
            套餐
          </div>
        </el-form-item>
        <el-form-item
                label="状态"
        >

          <div v-if="audit_status=='0'">
            未审核
          </div>
          <div v-else-if="audit_status=='1'">
            审核通过
          </div>
          <div v-else-if="audit_status=='2'">
            审核不通过
          </div>
        </el-form-item>
      <el-form-item
              label="备注"
      >
        {{audit_description}}
      </el-form-item>



    </el-form>

  </el-dialog>

</template>
<script>
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,
      agentname:"",
      goodsname:"",
      goodsprice:"",
      originalprice:"",
      goodsimg:"",
      total_num:"",
      user_num:"",
      insert_times:"",
      type:"",
      detailsimg:"",
      group_num:"",
      group_success_num:"",
      group_subsidy:"",
      audit_status:"",
      audit_description:"",
      category_name:"",
      category_two_name:"",
      meal_type:"",
      form: {

      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        let form = {};
        this.form = form;
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
        this.agentname=this.oneclass.agentname;
                this.goodsname=this.oneclass.goodsname;
                this.originalprice=this.oneclass.originalprice;
                this.goodsprice=this.oneclass.goodsprice;
                this.goodsimg=this.oneclass.goodsimg;
                this.detailsimg=this.oneclass.detailsimg;
                this.total_num=this.oneclass.total_num;
                this.user_num=this.oneclass.user_num;
                this.insert_times=this.oneclass.insert_times;
                this.type=this.oneclass.type;
                this.group_num=this.oneclass.group_num;
                this.group_success_num=this.oneclass.group_success_num;
                this.group_subsidy=this.oneclass.group_subsidy;
                this.audit_status=this.oneclass.audit_status;
                this.audit_description=this.oneclass.audit_description;

        this.category_name=this.oneclass.category_name;
        this.category_two_name=this.oneclass.category_two_name;
        this.meal_type=this.oneclass.meal_type;






          this.formEdit = true;
      }
    },
    aaaa(){
      window.open("https://www.kuaidi100.com/","_blank");
    },
    getImgUrl2(item){


      return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+item;
    },
      getImgUrl(){
        var good_url=this.goodsimg;
        if(good_url.match(",")){
          var str = good_url.split(',');
          good_url=str[1];
        }

        return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+good_url;
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

